import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SectionWrapper from '../../CardRow/SectionWrapper';
import DetailWrapper from '../../CardRow/DetailWrapper';
import { getMonthName } from '../../../utils/date';
import { useIntl } from 'react-intl';
import capitalize from '@material-ui/core/utils/capitalize';
import ButtonWrapper from '../../Button/ButtonWrapper';
import DefaultButton from '../../Button/DefaultButton';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import { useForm } from 'react-hook-form';
import CustomNumberFormat from '../../CustomizedComponents/CustomNumberFormat';

const quantitiesSkelet = () => {
  const skelet = [];
  for (let i = 1; i <= 12; i++) {
    skelet.push({ month: i, quantity: 0 });
  }
  return skelet;
};

const DeliveryVolumes = (
  {
    contract,
    handlers,
    editable,
    setEditable,
    isNew,
    handler,
    idPanel,
    setOpen,
  } ) => {
  const skelet = quantitiesSkelet();
  const {
    quantities,
    postLoadingContract,
    putLoadingContract,
  } = contract;

  const { setQuantities, sendHandler } = handlers;
  const intl = useIntl();
  const { handleSubmit, register, errors } = useForm();
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const cancel = 'app.buttons.cancel';
  const save = 'app.buttons.save';
  const continueTitle = 'app.buttons.continue';

  const handleChange = (idButton) => {
    if (!isNew) {
      setEditable(!editable);
      if (idButton !== 'cancel') {
        setOpen(true);
        sendHandler();
      }
    } else {
      handler(idPanel, true);
    }
  };

  useEffect(() => {
    if (!quantities) {
      setQuantities(skelet);
    }
  }, [quantities, setQuantities, skelet]);

  const pasteHandler = (event) => {
    const pastedData = event.clipboardData.getData('text');
    const dataSplited = pastedData.split('\n');

    if (dataSplited.length === 13) {
      setQuantities((oldState) => {
        const newState = [...oldState];
        for (let i = 0; i < 12; i++) {
          newState[i].quantity = dataSplited[i].trim();
        }
        return newState;
      });
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <>
      <DetailWrapper>
        <SectionWrapper>
          <form onSubmit={handleSubmit(handleChange)}>
            {quantities&&quantities.map( (item) => (
              <CustomTextField
                key={item.month}
                name={item.month.toString()}
                onChange={(event) => {
                  const quantityIndex = quantities.findIndex((e) => {
                    return e.month === item.month;
                  });
                  setQuantities((oldState) => {
                    const newState = [...oldState];
                    newState[quantityIndex].quantity = event.target.value;
                    return newState;
                  });
                }}
                label={`${capitalize(getMonthName(intl, new Date(2000, item.month - 1, 1)))} (MWh)`}
                value={item.quantity}
                variant="outlined"
                disabled={!editable}
                InputProps={{
                  inputComponent: CustomNumberFormat,
                }}
                inputRef={register({
                  required: dataMissing,
                })}
                helperText={(errors[item.month] && errors[item.month].message ) ? errors[item.month].message : ''}
                error={!!errors[item.month]}
                onPaste={pasteHandler}
              />
            ))}
            <ButtonWrapper>
              <DefaultButton
                id={'cancel'}
                primary={false}
                disabled={!editable}
                title={cancel}
                onClick={(event) => {
                  handleChange(event.currentTarget.id);
                }}
              />
              <DefaultButton
                primary={true}
                disabled={!editable}
                type="submit"
                title={isNew ? continueTitle : save}
                loaders={[postLoadingContract, putLoadingContract]}
              />
            </ButtonWrapper>
          </form>
        </SectionWrapper>
      </DetailWrapper>
    </>
  );
};

DeliveryVolumes.propTypes = {
  contract: PropTypes.object,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  isNew: PropTypes.bool,
  setEditable: PropTypes.func,
  handler: PropTypes.func,
  idPanel: PropTypes.any,
  setOpen: PropTypes.func,
};

export default DeliveryVolumes;
